import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsModule, TooltipModule } from 'ngx-bootstrap';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../../../shared/shared/shared.module';
import {SiteCreationComponent} from './site-creation/site-creation.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
  ],
  providers: [
  ],
  declarations: [
    SiteCreationComponent,
  ]
})
export class SiteCreationModule {
}
